export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/worker-legacy.d2312397.worker.js");
}
